import { render } from "./NotFoundPage.vue?vue&type=template&id=d6e1a700&scoped=true"
import script from "./NotFoundPage.vue?vue&type=script&lang=js"
export * from "./NotFoundPage.vue?vue&type=script&lang=js"

import "./NotFoundPage.vue?vue&type=style&index=0&id=d6e1a700&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d6e1a700"

export default script